const isProduction = process.env.NODE_ENV === 'production';

export const cosSectionCode: { [key: string]: string } = {
  MAIN_AD_POPUP: isProduction ? 'P_QBJY' : 'P_AMRJ',
  MAIN_NOTICE_POPUP: isProduction ? 'P_UJVP' : 'P_IQAS',
  MAIN_BANNER: isProduction ? 'B_WIXM' : 'B_NVVK',
} as const;
